module.exports = __webpack_public_path__ + "static/media/grinder_wheel_v3.038a36f7.png";